"use strict";
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useIntlMock = void 0;
var useIntlMock = function () {
    return {
        formatMessage: formatMessageMock,
    };
};
exports.useIntlMock = useIntlMock;
var formatMessageMock = function (descriptor, values) {
    var e_1, _a;
    var _b, _c, _d;
    if (!values) {
        var val = (_c = (_b = descriptor.defaultMessage) !== null && _b !== void 0 ? _b : descriptor.id) !== null && _c !== void 0 ? _c : "";
        return val;
    }
    var output = (_d = descriptor.defaultMessage) !== null && _d !== void 0 ? _d : "";
    var keys = Object.keys(values);
    try {
        for (var keys_1 = __values(keys), keys_1_1 = keys_1.next(); !keys_1_1.done; keys_1_1 = keys_1.next()) {
            var key = keys_1_1.value;
            var exp = new RegExp("\\{".concat(key, "\\}"), "g");
            output = output.replace(exp, values[key]);
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (keys_1_1 && !keys_1_1.done && (_a = keys_1.return)) _a.call(keys_1);
        }
        finally { if (e_1) throw e_1.error; }
    }
    return output;
};
